import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "task-controls" }

import { computed } from 'vue'

import { useI18n } from 'vue-i18n'
import { useTaskStore } from '@/store'
import Button from '@/components/ui/Button'

// Computed

export default /*#__PURE__*/_defineComponent({
  __name: 'TaskControls',
  emits: ["nextStep", "prevStep"],
  setup(__props, { emit: __emit }) {

const emit = __emit

// i18n
const { t } = useI18n()

// Store
const taskStore = useTaskStore()

// Components
const backText = computed<string>(() => {
  return (taskStore.isMainScreen) ? t('task.controls.back.first') : t('task.controls.back.other')
})
const nextText = computed<string>(() => {
  if (taskStore.isMainScreen) {
    return t('task.controls.next.first')
  }
  if (taskStore.isLastScreen) {
    return t('task.controls.next.last')
  }
  return t('task.controls.next.other')
})

// Methods
function next() {
  emit('nextStep')
}

function prev() {
  emit('prevStep')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Button), {
      theme: ['black', 'task-control'],
      onClick: prev
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(backText.value), 1)
      ]),
      _: 1
    }),
    _createVNode(_unref(Button), {
      theme: "task-control",
      onClick: next
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(nextText.value), 1)
      ]),
      _: 1
    })
  ]))
}
}

})